var _style, _path, _path2, _path3, _path4, _path5, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#XMLID_2_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#D83A59;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_19_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2534_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 15.298,
    y1: 62,
    x2: 104.702,
    y2: 62,
    gradientTransform: "matrix(1 0 0 -1 0 122)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#99D5C9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#4CB9DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2DA9E1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2535_",
    className: "st0",
    d: "M98.9,120H21.1c-3.2,0-5.8-2.6-5.8-5.8V5.8c0-3.2,2.6-5.8,5.8-5.8h77.7 c3.2,0,5.8,2.6,5.8,5.8v108.3C104.7,117.5,102.1,120,98.9,120z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2533_",
    className: "st1",
    d: "M81.2,61.5H28c-0.3,0-0.4-0.1-0.4-0.4v-5.7c0-0.3,0.1-0.4,0.4-0.4h53.1 c0.3,0,0.4,0.1,0.4,0.4v5.7C81.6,61.4,81.4,61.5,81.2,61.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2529_",
    className: "st1",
    d: "M92.3,77.9H27.9c-0.1,0-0.3-0.1-0.3-0.3v-2.9c0-0.1,0.1-0.3,0.3-0.3h64.4 c0.1,0,0.3,0.1,0.3,0.3v2.9C92.5,77.7,92.4,77.9,92.3,77.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2528_",
    className: "st1",
    d: "M92.3,92.3H27.9c-0.1,0-0.3-0.1-0.3-0.3v-2.9c0-0.1,0.1-0.3,0.3-0.3h64.4 c0.1,0,0.3,0.1,0.3,0.3v3C92.5,92.2,92.4,92.3,92.3,92.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2527_",
    className: "st1",
    d: "M92.3,105H27.9c-0.1,0-0.3-0.1-0.3-0.3v-2.9c0-0.1,0.1-0.3,0.3-0.3h64.4 c0.1,0,0.3,0.1,0.3,0.3v2.9C92.5,105,92.4,105,92.3,105z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_18_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_13_",
    className: "st2",
    cx: 60,
    cy: 27.3,
    r: 13.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M60.8,35.9h-1.7c-0.7,0-1.3-0.6-1.3-1.3V20c0-0.7,0.6-1.3,1.3-1.3h1.7c0.7,0,1.3,0.6,1.3,1.3 v14.6C62.1,35.4,61.5,35.9,60.8,35.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st1",
    d: "M68.6,26.5v1.7c0,0.7-0.6,1.3-1.3,1.3H52.7c-0.7,0-1.3-0.6-1.3-1.3v-1.7 c0-0.7,0.6-1.3,1.3-1.3h14.6C68,25.2,68.6,25.8,68.6,26.5z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/Medical.b61e2b3ef821818c656fb5ef5ea941fa.svg";
export { ForwardRef as ReactComponent };